var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"component-submit-progress"},[_vm._v(" "+_vm._s(_vm.text)+"("+_vm._s(_vm.progress)+"%) ")])
}
var staticRenderFns = []

export { render, staticRenderFns }